import React from 'react';
import { UseFormMethods } from 'react-hook-form';
import ContractAddendumClause from './redesign/ContractGenerationModels/ContractAddendumClause';
import LeaseClause from 'src/models/LeaseClause';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';

interface IClientApprovedLeaseClausesProps extends Partial<Pick<UseFormMethods, 'getValues' | 'register' | 'errors'>> {
    contractClauses: Array<ContractAddendumClause>;
    selectedClauses: Array<number>;
    isInHanded: boolean;

    updateProcessing: (current: number, selection: Array<number>) => void;
}

const ClientApprovedLeaseClauses = (props: IClientApprovedLeaseClausesProps) => {
    const isClauseSelected = (index: number) => {
        let currentSelection = [...props.selectedClauses];
        let formValues = props.getValues();
        let isSelected = formValues.contractClauses ? formValues.contractClauses[index]?.contractAddendumClauseId > 0 : false;
        let existing = currentSelection.indexOf(currentSelection.find(cs => cs === index));
        if (existing > -1 && isSelected === false) {
            currentSelection.splice(existing, 1);
        } else if (existing === -1 && isSelected === true) {
            currentSelection.push(index);
        }
        props.updateProcessing(index, currentSelection);
    };

    if (props.contractClauses?.length > 0) {
        return (
            <div>
                {props.contractClauses.map((clause: LeaseClause, index: number) => {
                    return (
                        <div
                            key={clause.leaseClauseType}
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'space-between',
                                rowGap: '2rem',
                                margin: '1rem 3rem 3rem',
                            }}
                        >        
                            <RHFSelect
                                bodyStyle={{ width: '18%'}}
                                name={`contractClauses[${index}].contractAddendumClauseId`}
                                label={clause.leaseClauseType}
                                register={props.register}
                                errors={props.errors}
                                options={[
                                    { value: clause.id, label: 'Yes' },
                                    { value: 0, label: 'No' },
                                ]}
                                disabled={props.isInHanded}
                                onChange={() => isClauseSelected(index)}
                            />
                            <div className={props.selectedClauses.find(sc => sc === index) !== undefined ? '' : 'disabled'} style={{ overflow: 'auto', width: '80%' }}>
                                {clause.clauseText || 'No Description'}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
    return <div />;
};

export default ClientApprovedLeaseClauses;


// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/ClientApprovedLeaseClauses.tsx